import React from "react";
import "./topNav.css";

import { BsFillPersonFill } from "react-icons/bs";import { FaFacebook } from "react-icons/fa";

const TopNav = () => {
  return (
    <div>
      <div className="main-header-wrapper">
        <h1 className="header">
          <span>N</span>rr Htg Yin Hlu - နားထောင်ရင်းလှူ
        </h1>
        <h3 className="subHead">
          <i> "Listen and Donate for Myanmar" </i>
        </h3>
      </div>
      <div className="topBtns">
        <a
          className="topBtn"
          target="_black"
          href="https://www.facebook.com/108228364876629/posts/108244881541644/"
        >
          <BsFillPersonFill className="icon" /> About Us
        </a>
        <a
          className="topBtn"
          target="_black"
          href="https://www.facebook.com/%E1%80%94%E1%80%AC%E1%80%B8%E1%80%91%E1%80%B1%E1%80%AC%E1%80%84%E1%80%BA%E1%80%9B%E1%80%84%E1%80%BA%E1%80%B8%E1%80%9C%E1%80%BE%E1%80%B0-Nrr-Htg-Yin-Hlu-108228364876629/"
        >
          <FaFacebook className="icon"></FaFacebook> Facebook Page
        </a>
      </div>
    </div>
  );
};

export default TopNav;
